// Verbindliche Quelle ist die Datei VERSION im Repo-Wurzelverzeichnis – siehe vite.config.ts,
// das den Wert als Vorgabe für VITE_APP_VERSION injiziert, sofern die Umgebungsvariable fehlt.
export const appVersion = import.meta.env.VITE_APP_VERSION;
